import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import RetractablePanel from 'components/RetractablePanel'
import Select from 'components/Select'
import InputFile from 'components/InputFile'
import Input from 'components/Input'
import Button from 'components/Button'
import DateInput from 'components/DateInput'
import TimeInput from 'components/TimeInput'
import ConfirmationModal from 'components/ConfirmationModal'
import ClaimSummary from './ClaimSummary/ClaimSummary'

import { statusChanged } from 'components/RequestStatus/actions'
import { claimChanged } from 'scenes/VehicleDetail/actions'

import { CLAIM_TYPES, CLAIM_UPDATE, CLAIM_CLOSE_REPORT } from 'constants'
import { STATES_URL, CITIES_URL } from 'constants'

import './styles.scss'

export class About extends BaseComponent {


  constructor(props) {
    super(props)
    this.state = {
      editting: false,
      sinister_file: {
        name: 'No se ha seleccionado archivo',
        file: '',
        status: false
      },
      type: {
        label: props.claim.type
      },
      isActive: props.claim.is_active,
      isClosed: props.claim.is_closed,
      number: props.claim.number,
      states: [],
      cities: [],
      state: '',
      stateName: '',
      city: '',
      cityName: '',
      cityObject: '',
      location_details: props.claim.location_details || '',
      incidence_date: '',
      incidence_time: '',
      errors: {
        issued_date: [],
        incidence_time: []
      }
    }

    this._bind( 
                '_getIncidenceDateValue',
                '_onEdit', '_renderEditForm', '_renderData', '_handleFileChange',
                '_handleSubmit', '_renderButton', '_renderFile',
                '_fetchTypes', '_getType', '_claimStatus', '_handleChange',
                '_fetchStates', '_onStateChange', '_onCityChange', '_convertToOption',
                '_getPlaceString',
                '_setCityValues', '_onCancelEdit',
                '_showConfirmSendReport', '_sendClosureReport', '_renderReportSent', '_didAccept')
  }

  _getIncidenceDateValue() {
    const claim = this.props.claim
    if (claim.incidence_date) {
      const incidence_date = moment(claim.incidence_date)
      const incidenceElement = incidence_date.format('YYYY-MM-DD')
      const incidenceTimeElement = incidence_date.format('HH:mm')
      this.setState({
        incidence_date: incidenceElement,
        incidence_time: incidenceTimeElement
      })
    }
  }

  componentDidMount() {
    this._setCityValues()
    this._getIncidenceDateValue()
    this._fetchStates()
  }

  _fetchTypes(label) {
    return request(CLAIM_TYPES)
      .then(({types}) => {
        const options = types.map((item) => ( { value: item.id, label: item.name } ))
        return { options }
      })
      .catch(console.log)
  }

  _onEdit(evt) {
    evt.preventDefault()
    this.panel.open()
    this.setState({ editting: true })
  }

  _onCancelEdit(evt) {
    evt.preventDefault()
    this.panel.open()
    this.setState({ editting: false })
  }

  _handleFileChange(e) {
    e.preventDefault()

    this.setState({
      sinister_file: {
        name: e.target.files[0].name,
        file: e.target.files[0],
        status: true
      }
    })
  }

  _convertToOption(item) {
    return { value: item.id, label: item.name }
  }

  _fetchStates() {
    return request(STATES_URL)
    .then((response) => {
      // const states = response.states.map(this._convertToOption)
      const states = response.states.map((item) => ( { value: item.id, label: item.name } ))
      this.setState({ states })
      return { states }
    })
    .catch((err) => console.log(err))
  }

  _onStateChange(selectedOption) {
    const stateID = !!selectedOption ? selectedOption.value : null
    this.setState({ state: stateID })

    // this.props.filterChanged(stateID, null)
    request(CITIES_URL(stateID))
    .then((response) => {
      const cities = response.cities.map(this._convertToOption)
      this.setState({ cities })
      return { cities }
    })
    .catch((err) => console.log(err))
  }

  _onCityChange(selectedOption) {
    const cityID = !!selectedOption ? selectedOption.value : null
    this.setState({ city: cityID, cityName: selectedOption.label })
  }

  _showClaimSummary() {
    this.context.toggleModal(true,
      <ClaimSummary
                  claimId={this.props.claimId}
                  claim={this.props.claim}
                  onSuccess={this._sendClosureReport.bind(this)}/>
    )
  }

  _renderHeaderActions() {
    return !this.state.editting ? (
      <div>
        <button onClick={this._onEdit}>
          <i className="material-icons">edit</i>
        </button>
      </div>
    ) : (
      <div>
        <button onClick={this._onCancelEdit}>
          <i className="material-icons">close</i>
        </button>
      </div>
    )
  }

  _claimStatus(e) {
    const formData = new FormData()
    formData.append([e.target.name], true)
    this.props.updateRequestStatus('progress', 'Cambiando estado de siniestro...')
    request(CLAIM_UPDATE(this.props.claim.id), {
      method: 'PUT',
      isUpload: true,
      body: formData
    }).then((res) => {
      this.setState({
        isActive: res.is_active,
        isClosed: res.is_closed,
      })
      this.props.updateRequestStatus('ok', 'Modificación exitosa')
    }).catch((err) => {
      this.props.updateRequestStatus('error', 'No pudimos modificar el estado')
    })
  }


  _renderButton() {
    const isActive = this.state.isActive
    const isClosed = this.state.isClosed
    if(isActive && isClosed === false) {
      return (
        <button type="button" className="btn btn-outline-danger" onClick={this._claimStatus} name="is_closed">Archivar</button>
      )
    } else {
      return (
        <button type="button" className="btn btn-outline-success" onClick={this._claimStatus} name="is_active">Iniciar seguimiento</button>
      )
    }
  }

  _handleSubmit(e) {
    e.preventDefault()
    const formData = new FormData()
    !!this.state.type.value && formData.append('type', this.state.type.value)
    formData.append('file', this.state.sinister_file.file)
    formData.append('number', this.state.number)
    formData.append('location_details', this.state.location_details)
    if(this.state.city) {
      formData.append('city', this.state.city)
    }
    let newDate = this.props.claim.incidence_date
    if(this.state.incidence_date && this.state.incidence_time){
      let dateTimeStr = this.state.incidence_date + ' ' + this.state.incidence_time
      formData.append('incidence_date', dateTimeStr)
      let dateStr = moment(dateTimeStr)
      newDate = dateStr.utc().format('YYYY-MM-DDTHH:mm:ss') + "Z"
    }
                                                      
    this.props.updateRequestStatus('progress', 'Modificando datos del siniestro...')
    request(CLAIM_UPDATE(this.props.claim.id), {
      method: 'PUT',
      isUpload: true,
      body: formData
    }).then((res) => {
      this.props.updateRequestStatus('ok', 'Datos modificados')
      const type = !!this.state.type.label ? this.state.type.label : this.props.claim.type
      this.props.claimChanged({
        ...this.props.claim,
        type: type,
        number: this.state.number,
        location_details: this.state.location_details,
        incidence_date: newDate,
        city: { 
          id: this.state.city,
          name: this.state.cityName,
          state: this.state.state
        }
      })
    }).catch((err) => {this.props.updateRequestStatus('error', 'No pudimos modificar los datos')})

    this.setState({
      editting: false
    })
  }

  _getType(selectedOption) {
    this.setState({
      type: selectedOption
    })
  }

  _handleChange(e) {
    if (e.target.name === 'incidence_time'){
      this.setState({ [e.target.name]: e.target.value })
      this.setState(
          { 
            errors: { incidence_time: e.target.errors }
          }
        )
      }
    else
      this.setState({ [e.target.name]: e.target.value })
  }

  _setCityValues(){
    let city = this.props.claim.city
    if (city){
      this.setState({
        state: city.state,
        city: city.id,
        cityName: city.name,
        stateName: city.state_name
      })
      this._onStateChange({ value: city.state, label: city.state_name })
    }
  }

  _loadCityNames() {
    // if (this.state.state) 
    //   this._onStateChange({ value: this.state.state, label: this.state.stateName })
  }

  _renderEditForm() {
    return(
      <form onSubmit={this._handleSubmit} className="SinisterDataAbout__form">
        <div className="form-field">
          <label>Folio:</label>
          <Input  onChange={this._handleChange}
                name="number"
                value={this.state.number}
                placeholder="Folio de siniestro"/>
        </div>
        <div className="form-select-field-type">
          <label>Tipo de siniestro:</label>
          <Select errors={[]}
                  loadingPlaceholder="Buscando..."
                  loadOptions={this._fetchTypes}
                  noResultsText='Sin resultados'
                  onChange={this._getType}
                  placeholder="Seleccionar tipo"
                  searchPromptText="Escribe para comenzar la búsqueda"
                  value={this.state.type} />
        </div>
        {/* <Select errors={[]}
                label="Tipo de siniestro"
                loadingPlaceholder="Buscando..."
                loadOptions={this._fetchTypes}
                noResultsText='Sin resultados'
                onChange={this._getType}
                placeholder="Seleccionar tipo"
                searchPromptText="Escribe para comenzar la búsqueda"
                value={this.state.type} /> */}
        <div className="form-field">
          <label>Fecha del siniestro:</label>
          <DateInput
                errors={this.state.errors.issued_date}
                name="incidence_date"
                onChange={this._handleChange}
                value={this.state.incidence_date} />
        </div>
        <div className="form-field">
          <label>Hora:</label>
          <TimeInput  
                errors={this.state.errors.incidence_time}
                onChange={this._handleChange}
                name="incidence_time"
                value={this.state.incidence_time}
                />
        </div>
        <div className="form-select-field-state">
          <label>Estado:</label>
          <Select errors={[]}
                loadingPlaceholder="Buscando..."
                options={this.state.states}
                noResultsText='Sin resultados'
                onChange={this._onStateChange}
                placeholder="Estado"
                searchPromptText="Escribe para buscar"
                value={this.state.state}  />
        </div>
        <div className="form-select-field-city">
          <label>Ciudad:</label>
          <Select
                placeholder="Ciudades"
                value={this.state.city}
                options={this.state.cities}
                onChange={this._onCityChange}  />
        </div>
        {/*  <Select errors={[]}
                label="Ubicación del siniestro"
                loadingPlaceholder="Buscando..."
                options={this.state.states}
                noResultsText='Sin resultados'
                onChange={this._onStateChange}
                placeholder="Estado"
                searchPromptText="Escribe para buscar"
                value={this.state.state}  /> 

        <Select
                placeholder="Ciudades"
                value={this.state.city}
                options={this.state.cities}
                onChange={this._onCityChange}  /> 

        <Input  
                onChange={this._handleChange}
                name="location_details"
                value={this.state.location_details}
                placeholder="Referencia de lugar"/> */}

        <div className="form-field">
          <label>Referencia del lugar:</label>
          <Input  
                onChange={this._handleChange}
                name="location_details"
                value={this.state.location_details}
                placeholder="Referencia de lugar"/>          
        </div>
        <br></br>
        <InputFile  file={this.state.sinister_file}
                    onChange={this._handleFileChange}
                    label="Archivo de declaración" />
        <div className="controls d-flex justify-content-end">
          <Button buttonType="primary"
                  size="small">Actualizar siniestro</Button>
        </div>
      </form>
    )
  }

  _renderFile() {
    return !!this.props.claim.file ? (
      <a href={this.props.claim.file} target="_blank">
        <i className="material-icons">file_download</i>
        <span>Descargar declaración</span>
      </a>
    ) : (
        <p><span>Declaración no registrada</span></p>
    )
  }

  _getPlaceString(){
    const states = this.state.states
    const city = this.props.claim.city
    let placeString = ""
    if (city && city.state){
      for (var i = 0; i < states.length; i++){
        if (states[i].value === city.state) {
          placeString = states[i].label + ", " + city.name
          break
        }
      }
    }
    return placeString
  }

  _showConfirmSendReport(e){
    e.preventDefault()
    var title = "Confirmación de reporte de cierre de siniestro"
    var message = "El reporte de cierre debe ser enviado al final de un siniestro. Esta confirmación desencadenará el envío de un reporte del siniestro por correo y una notificación final."
    this.context.toggleModal(
      true,
      <ConfirmationModal 
                        _onAccept={this._didAccept.bind(this)}
                        match={this.props.match} 
                        title={title}
                        acceptLabel="Enviar"
                        message={message}
                        hideModal={this.props.claim.summary !== ''}
      />
    )
  }

  _didAccept(){
    if (this.props.claim.summary !== '') {
      this._sendClosureReport()
    }else{
      this._showClaimSummary()
    }
  }

  _sendClosureReport(){
    this.props.updateRequestStatus('progress', 'Procesando ...')
    request(CLAIM_CLOSE_REPORT(this.props.claim.id), {
      method: 'GET',
      isUpload: true,
      body: null
    }).then((res) => {
      this.props.updateRequestStatus('ok', res.message)
      this.props.claimChanged({
        ...this.props.claim,
        close_report_date: res.sent_date,
        close_report_sent: true
      })
      this.context.toggleModal(false)
    }).catch((err) => {
      this.props.updateRequestStatus('error', 'Error al enviar el reporte')
    })
  }

  _showReportSent(e){
    this.setState({ request: { status: 'ok', message: 'Reporte enviado.'}})
    this.props.updateRequestStatus('ok', 'Reporte enviado.')
  }

  _renderReportSent(){
    var sent_date = ''
    const claim = this.props.claim
  
    if (this.props.claim.close_report_date) {
      const date = moment(claim.close_report_date)
      sent_date = date.format('DD-MM-YYYY')
    }
    
    return !!this.props.claim.close_report_sent ? (
        <p><strong>Reporte generado: {sent_date}</strong></p>
    ) : null
  }

  _renderData() {
    const claim = this.props.claim
    const date = moment(claim.created)
    const dateElement = date.format('DD-MM-YYYY')
    const placeString = this._getPlaceString()

    var incidenceElement = ''
    var incidenceTimeElement = ''
    if (claim.incidence_date){
      const incidence_date = moment(claim.incidence_date)
      incidenceElement = incidence_date.format('DD-MM-YYYY')
      incidenceTimeElement = incidence_date.format('HH:mm')
    }
      
    return(
      <div className="SinisterDataAbout__data">
        <div className="data-field-strong">
          <label>Tipo de siniestro:</label>
          <p><span>{claim.type}</span></p>
        </div>
        <div className="data-field">
          <label>Folio:</label>
          <p><span>{claim.number}</span></p>
        </div>
        <div className="data-field">
          <label>Creado el:</label>
          <p><span>{dateElement}</span></p>
        </div>
        <div className="data-field">
          <label>Fecha del siniestro:</label>
          <p><span>{incidenceElement || '-'}</span></p>
        </div>
        <div className="data-field">
          <label>Hora del siniestro:</label>
          <p><span>{incidenceTimeElement || '-'}</span></p>
        </div>
        <div className="data-field">
          <label>Lugar:</label>
          <p><span>{placeString || '-'}</span></p>
        </div>
        <div className="data-field">
          <label>Referencia del lugar:</label>
          <p><span>{claim.location_details || '-'}</span></p>
        </div>
        <br></br>
        {this._renderFile()}
        <div className="d-flex flex-row report">
        <Button className="report_button" size="sm" onClick={this._showConfirmSendReport}>
          <i className="material-icons">assessment</i>
            Enviar reporte de cierre
         </Button>
         {this._renderReportSent()}
        </div>
        {this._renderButton()}
      </div>
    )
  }

  render() {
    return(
      <div id="SinisterAbout" className="SinisterAbout">
        <RetractablePanel
          ref={(panel) => this.panel = panel}
          name="Acerca del siniestro"
          actionButtons={this._renderHeaderActions()}
          isToggle={true}
        >
          {this.state.editting ? this._renderEditForm() : this._renderData() }
        </RetractablePanel>
      </div>
    )
  }
}

About.contextTypes = {
  toggleModal: PropTypes.func.isRequired
}

const mapStateToProps = (state) => {
  return {
    claim: state.vehicleDetail.get('claim')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message)),
    claimChanged: (vehicle) => dispatch(claimChanged(vehicle))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(About)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/ClaimData/About/index.js